import React, { useContext, useState } from "react";
import {
  Badge,
  Text,
  LegacyCard as Card,
  Link,
  Thumbnail,
  InlineStack,
  Icon,
  Button,
  ButtonGroup,
  FormLayout,
  Checkbox,
  Box,
  BlockStack,
  Divider,
} from "@shopify/polaris";
import { NoteIcon, CartSaleIcon, ReturnIcon } from "@shopify/polaris-icons";

import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { baseHelper, imageHelper } from "lib/helpers";
import { StyledCard } from "app/orders/modules/operator/features/view/genericStyled";
import Popover from "app/orders/modules/provider/features/view/features/popover";
import { useNavigate, useParams } from "react-router-dom";

const ReadyForCollect = (props) => {
  const {
    itemData,
    openClickReserveModal,
    refundData,
    selectedItems,
    setSelectedItems,
    setSelectedReserveItemData,
    selectedReserveItemData,
    setIsBulkReserveChecked,
    isBulkReserveChecked,
    setBulkQuantity,
    bulkQuantity,
    setActiveReserveCollect,
  } = props;
  const { cms, userData } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const currentUserData = baseHelper.getResponseData(userData, constant.gql.GET_CURRENT_USER);

  const [activePopover, setActivePopover] = useState({});

  const handleChange = (value) => {
    const { fulfillmentStatus, _id: id, collectDetail } = value;
    if (fulfillmentStatus === constant.UNFULFILLED && collectDetail) {
      const found = selectedItems.find((element) => element === id);
      if (found) {
        setSelectedItems(
          selectedItems.filter((item) => {
            return item !== id;
          })
        );
        setSelectedReserveItemData(selectedReserveItemData.filter((item) => item._id !== id));
        setBulkQuantity(bulkQuantity.filter((item) => item.id !== id));
      } else {
        setSelectedItems([...selectedItems, id]);
        setSelectedReserveItemData([...selectedReserveItemData, value]);
        setBulkQuantity([
          ...bulkQuantity,
          {
            id: value._id,
            quantity: value.fulfillableQuantity.toString(),
            totalQuantity: value.actualQuantity.toString(),
          },
        ]);
      }
    }
  };

  const amount = [];
  const vendorsSum = [];
  const countItems = 0;

  itemData
    .filter(
      (lineItem) =>
        lineItem.fulfillmentStatus !== constant.FULFILLED &&
        [constant.RESERVE, constant.COLLECT].includes(lineItem.fulfillmentType) &&
        lineItem.collectDetail &&
        (!lineItem.isRefund
          ? parseInt(lineItem.actualQuantity || lineItem.quantity, 10) -
          parseInt(lineItem.collectDetail.readyQuantity, 10) <
          parseInt(lineItem.fulfillableQuantity, 10)
          : !(
            parseInt(lineItem.quantity, 10) - parseInt(lineItem.fulfillableQuantity, 10) ===
            parseInt(lineItem.collectDetail.readyQuantity, 10)
          ))
    )
    .forEach(({ vendor }) => {
      vendorsSum.push(vendor);
      return vendorsSum;
    });

  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;
  const lineDataItems = itemData.filter(
    (lineItem) =>
      lineItem.fulfillmentStatus !== constant.FULFILLED &&
      [constant.RESERVE, constant.COLLECT].includes(lineItem.fulfillmentType) &&
      lineItem.collectDetail
  ).length;
  const isVendor = baseHelper.isVendor(currentUserData);

  const lineItems =
    itemData &&
    itemData.length &&
    itemData
      .filter(
        (item) =>
          [constant.UNFULFILLED, constant.PARTIAL].includes(item.fulfillmentStatus) &&
          [constant.RESERVE, constant.COLLECT].includes(item.fulfillmentType) &&
          item.collectDetail
      )
      .map((lineData, idx) => {
        const {
          _id: id,
          actualQuantity = 0,
          collectDetail = {},
          fulfillableQuantity = 0,
          image = "",
          isProductDeleted,
          isRefund = false,
          isVendorDeleted,
          moneyFormat: lineMoneyFormat,
          name,
          productId,
          price,
          quantity = 0,
          sku,
          shopifyLineItemId,
          status,
          title,
          vendor,
          vendorId,
          fulfillmentType: lineItemFulfillmentType,
        } = lineData || {};

        let { readyQuantity = 0 } = collectDetail || {};
        isRefund &&
          refundData &&
          refundData
            .filter((item) => item.line_item_id === shopifyLineItemId)
            .forEach((refundItem) => {
              const { totalQuantity = 0 } = refundItem;
              readyQuantity -= totalQuantity;
            });
        const lineItemKey = `lineItem${idx}`;
        const lineImage =
          imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;

        const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;

        const newQuantity = parseInt(actualQuantity || quantity) - parseInt(fulfillableQuantity);
        const readyCollectQuantity = parseInt(readyQuantity) - parseInt(newQuantity);

        if (!readyCollectQuantity) {
          return null;
        }

        const totalPrice = price * readyCollectQuantity;

        amount.push(totalPrice);

        const lineItemName = <div className="productName">{name}</div>;

        return (
          <div key={lineItemKey} className="fulfilled-Secn">
            <Box padding="400">
              <InlineStack wrap={false} align="space-between">
                <InlineStack gap="400">
                  <Thumbnail size="large" source={lineImage} alt={name} />
                  <BlockStack gap="100">
                    {(isProductDeleted && (lineItemName || "")) || (
                      <Link onClick={() => navigate(`/products/edit/${productId}`)}>{name || ""}</Link>
                    )}


                    <Text as="span" variant="bodySm" tone={constant.SUBDUED}>
                      {vendor ? `${cms("label.vendor")}: ${vendor}` : ""}
                    </Text>
                    {/* {sku && ( */}
                    <Text as="span" variant="bodySm" tone={constant.SUBDUED}>
                      {cms("label.skuList")}
                      {sku}
                    </Text>
                    {/* )} */}

                    <InlineStack gap="400">
                      <Badge status={baseHelper.getBadgeType(status)} className="text-capitalize">
                        {readyQuantity < quantity ? cms("label.partialReady") : cms("label.readyForCollection")}
                      </Badge>

                      <Button variant="plain" size="slim" onClick={() => window.open(`/order-slip/${id}`)}>
                        <InlineStack gap="2" blockAlign="center">
                          <Icon source={NoteIcon} />
                          {lineItemFulfillmentType === constant.RESERVE && (
                            <Text as="span">{`${cms("label.reserveSlip")}`}</Text>
                          )}
                          {lineItemFulfillmentType === constant.COLLECT && (
                            <Text as="span">{`${cms("label.pickupSlip")}`}</Text>
                          )}
                        </InlineStack>
                      </Button>
                    </InlineStack>
                  </BlockStack>
                </InlineStack>
                <InlineStack gap="400">
                  <Text as="span">{` ${cms("label.qty")}: ${readyCollectQuantity}`}</Text>
                  <Text as="h5">
                    {moneyFormat}
                    {(totalPrice && totalPrice.toFixed(2)) || constant.value.ZERO}
                  </Text>
                </InlineStack>
              </InlineStack>
            </Box>
          </div>
        );
      });

  const stringToNumber = amount.map((item) => parseFloat(item));
  const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);

  const moneyFormat = (itemData && itemData.length && itemData[0].moneyFormat) || constant.symbol.DOLLAR;
  const totalFulfill = (
    <>
      <Divider />
      <Box padding="400">
        <InlineStack align="space-between" blockAlign="center">
          <Text as="span" fontWeight="semibold">
            {cms("label.total")}
          </Text>
          <InlineStack gap="400">
            <Text variant="bodySm" as="p">
              (
              {lineDataItems > 1
                ? `${lineDataItems}
                ${cms("label.items")} from ${addVendorTxt}`
                : `${lineDataItems}
                ${cms("label.item")} from ${addVendorTxt}`}
              )
            </Text>
            <Text as="span" fontWeight="semibold">{`${moneyFormat}${totalAmount.toFixed(2)}`}</Text>
          </InlineStack>
        </InlineStack>
      </Box>
    </>
  );

  return [lineItems, totalFulfill];
};

export default ReadyForCollect;
